<template>
  <div>
    <figure class="product-image-area">
      <slot></slot>
      <div class="product-badges">
        <product-badge class="product-badge"
                       v-if="coming_soon"
                       start-color="hsla(50, 100%, 70%, 1)"
                       stop-color="hsla(50, 100%, 30%, 1)"
                       stroke-color="hsla(50, 100%, 50%, 1)"
                       text-fill="#000000"
                       :words="['COMING','SOON']"/>
        <product-badge class="product-badge"
                       v-if="close_out"
                       start-color="hsla(113, 100%, 50%, 1)"
                       stop-color="hsla(113, 100%, 0%, 1)"
                       stroke-color="#hsla(113, 100%, 33%, 1)"
                       text-fill="#000"
                       :words="['CLOSE','OUT']"/>
        <product-badge class="product-badge"
                       v-if="new_item"
                       start-color="hsla(250, 100%, 50%, 1)"
                       stop-color="hsla(250, 100%, 0%, 1)"
                       stroke-color="hsla(250, 100%, 33%, 1)"
                       :words="['NEW','ITEM']"/>
        <product-badge class="product-badge"
                       v-if="limited_time"
                       start-color="hsla(36, 98%, 58%, 1)"
                       stop-color="hsla(36, 87%, 44%, 1)"
                       stroke-color="hsla(33, 100%, 45%, 1)"
                       text-fill="#000"
                       :words="['LIMITED','TIME']"/>
      </div>
    </figure>
    <div class="symbol-holder">
      <span v-for="symbol in lotion_symbols"
            class="symbol"
            :class="symbol"
            :title="symbol"
            :key="product.id+symbol"></span>
    </div>
    <div class="flyer-text" v-if="flyer_text">
      <product-badge class="product-badge special-offer"
                     :font-size="50"
                       :words="['SPECIAL','OFFER']"/>
      <div v-html="flyer_text"></div>
    </div>
  </div>
</template>

<script>
  import ProductBadge from "./heartland-product-badge.vue"
  import {
    currentlyAfter,
    currentlyBetweenDates
  } from "vue-src/utils/dates"
  import {showAddToCart} from "^/utils/scopeHelpers"

  export default {
    name: "base-product-image-area",
    components: {ProductBadge},
    data() {
      return {}
    },
    props: {
      product: {
        type: Object,
        required: true,
      },
    },
    methods: {
      stripWhite(words) {
        return words.replace(/\s/g, '-')
      }
    },
    computed: {
      showAddToCart,
      lotion_symbols() {
        return this.product.lotion_symbols || []
      },
      coming_soon(){
        return currentlyBetweenDates(
            this.product.coming_soon_start_date,
            this.product.coming_soon_end_date
        )
      },
      new_item(){
        return currentlyBetweenDates(
            this.product.new_item_start_date,
            this.product.new_item_end_date
        )
      },
      limited_time() {
        return currentlyAfter(this.product.limited_start_date)
      },
      close_out() {
        return currentlyAfter(this.product.closeout_date)
      },
      flyer_text(){
        if(!this.showAddToCart) return false
        const show_flyer = currentlyBetweenDates(
            this.product.flyer_begin_date,
            this.product.flyer_end_date,
            inclusive=true,
        )
        return show_flyer?this.product.flyer_text:''
      }
    }
  }
</script>

<style scoped>
  .symbol-holder {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .product-image-area {
    position: relative;
  }

  .product-badges {
    position: absolute;
    bottom: 0%;
    left: 0%;
    padding:5%;
    display:flex;
    flex-flow: column-reverse nowrap;
    height:100%;
    width:30%;
  }
  .product-badge{
    height: 20%;
  }

  .flyer-text{
    display:flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    margin:2px;
    font-weight:700;
  }
  .product-badge.special-offer{
    height: 100px;
    /* width: 150px; */
    max-width: 50px;
    margin-right: 10px;
  }

  .symbol {
    margin: 0 2px;
  }

</style>



// WEBPACK FOOTER //
// ixcms/themes/heartlandtan/src/vue-src/base/_base-product-image-area.vue